import PlatformBreakoutChartCard from './PlatformBreakoutChartCard';

export default PlatformBreakoutChartCard;
